"use client"

import { useEffect, useRef } from 'react'
import { usePrerenderSafeSearchParams } from '@/hooks/use-prerender-safe-search-params'
import { toolNavigationAnalytics } from '@/lib/analytics'

export function useFromTool(currentToolId: string) {
  const searchParams = usePrerenderSafeSearchParams()
  const firedRef = useRef(false)

  useEffect(() => {
    if (firedRef.current) return
    const fromTool = searchParams.get('fromTool')
    if (!fromTool) return
    firedRef.current = true
    toolNavigationAnalytics.referredVisit({
      targetTool: currentToolId,
      fromTool,
    })
  }, [searchParams, currentToolId])
}
